import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { GlobeIcon } from 'lucide-react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'ui/select'
import { toast } from 'ui/sonner'

import { apiClient } from '~/api/client'
import { LinearSlideAnimation } from '~/components/linear-slide-animation'
import { LS_JWT_KEY } from '~/const/api'
import { langWithoutRegion } from '~/utils/lang-without-region'

export const LanguageSelect = () => {
  const { i18n, t } = useTranslation()
  const [isLanguageLoading, setIsLanguageLoading] = useState(false)

  useEffect(() => {
    const onFailedLoading = () => toast.error(t('Can t load translations They will be loaded later'))
    i18n.on('failedLoading', onFailedLoading)

    return () => i18n.off('failedLoading', onFailedLoading)
  }, [i18n, t])

  const onLanguageChange = (lng: string) => {
    setIsLanguageLoading(true)
    void i18n.changeLanguage(lng).finally(() => setIsLanguageLoading(false))
    if (localStorage.getItem(LS_JWT_KEY))
      apiClient
        .GET('/user/meta', { params: { header: { 'x-app-locale': lng.split('-')[0] || 'en' } } })
        .catch(error => {
          toast.error(t('Network error'))
          console.error({ message: 'Network error', error })
        })
  }

  return (
    <div>
      <Select defaultValue={langWithoutRegion(i18n.language)} onValueChange={onLanguageChange}>
        <SelectTrigger aria-label={t('App language')} className="w-fit min-w-[10rem]">
          <div className="flex items-center gap-3">
            <GlobeIcon aria-hidden />
            <SelectValue />
          </div>
        </SelectTrigger>
        <SelectContent>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <SelectItem value="en">English</SelectItem>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <SelectItem value="de">Deutsche</SelectItem>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <SelectItem value="uk">Українська</SelectItem>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <SelectItem value="ru">Русский</SelectItem>
          {/* eslint-disable-next-line react/jsx-no-literals */}
          <SelectItem value="tr">Türkçe</SelectItem>
        </SelectContent>
      </Select>
      <LinearSlideAnimation isLoading={isLanguageLoading} />
    </div>
  )
}
